import { gql } from '@biletiniz/apollo';
export const CONFIRM = gql`
  mutation verifyUser($session:String!, $confirmCode:String! ){
    verifyUser(session: $session, confirmCode: $confirmCode){
      message
      session
      status
      token {
        accessToken
        accessTokenExpiresAt
        refreshToken
        refreshTokenExpiresAt
        user {
          name
          surname
          email
          phoneNumber
          balance {
            amount
            currency
          }
        }
      }
    }
  }
`;